define(function (require){
    "use strict";

    var LPTCollection   = require('vendor/Backbone/LPTCollection');
    var Model           = require('models/notepad');

    return LPTCollection.extend({ model : Model });
});